<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<el-form :inline="true" :model="formInline" class="user-search">
				<el-form-item label="角色名称：">
					<el-input clearable v-model="formInline.roleName" size="small" placeholder="请输入角色名称" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
					<el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
				</el-form-item>
				<el-form-item style="float: right; margin-right: 0">
					<el-button size="small" type="primary" class="el-icon-plus" @click="handleEdit()">新增</el-button>
					<my-column-filter :list-columns="listColumns" @hide-pop="getCheckBox"></my-column-filter>
				</el-form-item>
			</el-form>
			<STable :columns="columnsData" :data="listData" :loading="loading" :height="tableHeight" @get-data="getListData" @handle-command="handleCommand" @row-click="handleRowClick"></STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
		<!-- 编辑 -->
		<edit ref="edit"></edit>
		<!-- 权限配置 -->
		<menuAccess ref="menuAccess"></menuAccess>
		<!-- 角色关联用户 -->
		<userAccess ref="userAccess"></userAccess>
	</div>
</template>

<script>
import { getRoleListForPage, DeleteRoleInfo } from "../../../api/userApi.js";
import edit from "./edit";
import userAccess from "./userAccess.vue";
import menuAccess from "./menuAccess.vue";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "角色列表"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			tableHeight: "calc(100vh - 300px)",
			listData: [],
			selectionList: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 15,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 15,
				roleName: ""
			},
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "60",
					isKeep: true
				},
				{
					prop: "roleName",
					label: "角色名称",
					isKeep: true,
					width: "130",
					align: "center"
				},
				{
					prop: "desc",
					label: "角色描述",
					width: "300",
					align: "center"
				},
				{
					prop: "menuName",
					label: "角色权限"
				},
				{
					operation: true,
					isKeep: true,
					label: "操作",
					btnGroup: [
						{
							icon: "el-icon-attract",
							name: "授权",
							type: "1"
						},
						{
							icon: "el-icon-document-copy",
							name: "关联用户",
							type: "3",
							btnType: "primary"
						},
						{
							icon: "el-icon-delete",
							name: "删除",
							type: "4",
							btnType: "danger"
						}
					]
				}
			]
		};
	},
	// 注册组件
	components: {
		edit,
		menuAccess,
		userAccess
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));

		this.getListData();
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		handleCommand(command) {
			// 1编辑
			switch (command.command) {
				case "1":
					this.menuAccess(command.rowData);
					break;
				case "3":
					this.userAccess(command.rowData);
					break;
				case "4":
					this.deleteUser(command.rowData);
					break;
				default:
					console.log(command);
			}
		},

		// 单击行数据
		handleRowClick(row) {
			this.$refs.edit.editShow(row);
		},
		// 关联用户
		userAccess(row) {
			this.$refs.userAccess.userAccess(row);
		},
		menuAccess(row) {
			this.$refs.menuAccess.menuAccess(row);
		},
		//显示编辑界面
		handleEdit(row) {
			this.$refs.edit.editShow(row);
		},
		// 删除
		deleteUser(row) {
			this.$confirm("确定要删除<" + row.roleName + ">吗?", "信息", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				let parmter = {
					keyId: row.keyId
				};
				DeleteRoleInfo(parmter)
					.then((res) => {
						if (res.code === 1) {
							this.$message({
								type: "success",
								message: "已删除!"
							});
							this.getListData();
						} else {
							this.$message({
								type: "info",
								message: res.msg
							});
						}
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error("删除失败，请稍后再试！");
					});
			});
		},
		// 获取列表
		getListData() {
			this.loading = true;
			getRoleListForPage(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.search();
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		}
	}
};
</script>

<style scoped></style>
